import { Button } from "../../../../../core/components/atoms/Button"
import { useNavigate, useParams } from "react-router-dom";

interface SubmitFooterProps {
  handleSubmit: () => void;
  onCancel?: () => void;
  cancelLabel?: string;
  submitLabel?: string;
}

const SubmitFooter = ({
  handleSubmit,
  onCancel,
  cancelLabel = 'Cancelar',
  submitLabel = 'Adicionar',
}: SubmitFooterProps) => {
  const navigate = useNavigate();
  const { scheduleId } = useParams();

  const handleCancel = () => {
    if (onCancel) {
      onCancel();
      return;
    }

    navigate(`/plano-adaptativo/${scheduleId}/hub`);
  };

  return (
    <div 
      className={
        `w-full fixed bottom-0 left-0 right-0 h-[4rem] 
        px-2 py-8 md:px-10 lg:px-20 
        bg-mono-color-lightest 
        flex justify-between items-center gap-lg 
      `
      }
    >
      <div className="w-1/3">
        <Button
          variant='outlined'
          onClick={handleCancel}
          full
        >
          {cancelLabel}
        </Button>
      </div>
      <div className="w-2/3">
        <Button
          onClick={handleSubmit}
          full
        >
          {submitLabel}
        </Button>
      </div>
    </div>
  )
}

export default SubmitFooter;
